import { useTranslation } from 'react-i18next';
import styles from 'pages/assistant/components/artifacts/components/fineco-portfolio/finecoPortfolio.common.module.scss';
import linkStyles from 'pages/assistant/components/finecoDownloadButton.module.scss';
import { FinecoButton } from 'pages/assistant/components/FinecoButton';
import { GenerateReport } from './GenerateReport';
import { FinecoDownloadButton } from 'pages/assistant/components/FinecoDownloadButton';
import { FinecoDownloadIcon } from 'shared/assets/svg/FinecoDownloadIcon';
import { EuroIcon } from 'shared/assets/svg/EuroIcon';
import { SimulazioneCostiModal } from './SimulazioneCosti';

type FinecoPortfolioButtonsProps = {
  generatingPdf: boolean;
  generatingDownloadPdf: boolean;
  requestGeneratePdfAction: (reportSpec: any, fromReport?: boolean) => Promise<void>;
  handleSavePortfolio: () => void;
  handleEmailClick: () => void;
  handleImportToXnet?: () => void;
  setGeneratingDownloadPdf: (generating: boolean) => void;
  generateReportRef: React.RefObject<any>;
  artifact: any;
  threadId?: string;
  portfolioId?: string;
  portfolioData?: any;
  countervalueTotal?: number;
  commentoAlPortafoglio?: boolean;
  canImportToXnet?: boolean;
  canSavePortfolio?: boolean;
};
export const FinecoPortfolioButtons: React.FC<FinecoPortfolioButtonsProps> = ({
  generatingPdf,
  generatingDownloadPdf,
  requestGeneratePdfAction,
  handleSavePortfolio,
  handleEmailClick,
  handleImportToXnet,
  setGeneratingDownloadPdf,
  generateReportRef,
  artifact,
  threadId,
  portfolioId,
  portfolioData,
  countervalueTotal,
  commentoAlPortafoglio,
  canImportToXnet = false,
  canSavePortfolio = true,
}) => {
  const { t } = useTranslation();
  const isGenerating = generatingPdf || generatingDownloadPdf;

  return (
    <div className={styles.buttonContainer}>
      {/* Links section */}
      <div className={styles.linksSection}>
        <FinecoDownloadButton
          click={() => {
            setGeneratingDownloadPdf(true);
            generateReportRef.current.generate(false);
          }}
          copy={!generatingDownloadPdf ? t('generateReport.download') : t('generateReport.downloading')}
          disabled={isGenerating}
        />
        <GenerateReport
          artifact={{
            financial_plan: artifact.data?.financial_plan,
            risk_profile: artifact.data?.risk_profile,
          }}
          onGenerate={requestGeneratePdfAction}
          ref={generateReportRef}
          threadId={threadId}
          portfolioId={portfolioId}
          portfolioData={portfolioData}
          countervalueTotal={countervalueTotal}
          commentoAlPortafoglio={commentoAlPortafoglio}
          disabled={isGenerating}
        >
          <div
            className={linkStyles.buttonContainer}
            style={isGenerating ? { opacity: 0.5, pointerEvents: 'none' } : undefined}
          >
            <div className={linkStyles.icon}>
              <FinecoDownloadIcon />
            </div>
            <div className={linkStyles.buttonCopy}>
              {!generatingPdf ? t('generateReport.modify') : t('generateReport.downloading')}
            </div>
          </div>
        </GenerateReport>
        {portfolioData && portfolioId && (
          <SimulazioneCostiModal portfolioData={portfolioData} portfolioId={portfolioId}>
            <div className={linkStyles.buttonContainer}>
              <div className={linkStyles.icon}>
                <EuroIcon />
              </div>
              <div className={linkStyles.buttonCopy}>Simula costi</div>
            </div>
          </SimulazioneCostiModal>
        )}
      </div>

      {/* Buttons section */}
      <div className={styles.buttonsSection}>
        <FinecoButton click={handleEmailClick} copy={t('generateReport.sendViaMail').toUpperCase()} variant="white" />
        <FinecoButton click={handleSavePortfolio} copy={t('actions.saveMyPortfolio').toUpperCase()} disabled={!canSavePortfolio} />
        {handleImportToXnet && (
          <FinecoButton click={handleImportToXnet} copy={t('actions.importToXnet').toUpperCase()} disabled={!canImportToXnet} />
        )}
      </div>
    </div>
  );
};
